import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import VehicleDetails from 'Components/MultiModeAddTrip/VehicleDetails';
import BiddingDetails from 'Components/MultiModeAddTrip/BiddingDetails';
import LegDetails from 'Components/MultiModeAddTrip/LegsDetails';
import Costs from 'Components/MultiModeAddTrip/Costs';
import MinimizedTrip from 'Components/MultiModeAddTrip/MinimizedTrip';

import { ReactComponent as CloseIcon } from 'Icons/close.svg';
import { ReactComponent as MinimizeIcon } from 'Icons/minimize.svg';
import { ReactComponent as TrashIcon } from 'Icons/trash.svg'
import { TAT_UNITS, PAYM, AVG_DISTANCE, HIKAL } from 'Constants/commonConstants';
import { GET_LPP_DETAILS } from 'Constants/actionConstants';

import Trip from 'Models/Trip';

// import LadyImage from 'Icons/lady.png';
import TruckPreview from 'Icons/truckPreview2.png';

import Heading from 'Components/Heading';

import LivePreview from 'Components/MultiModeAddTrip/LivePreview';

import TripStatusBar from 'Components/MultiModeAddTrip/TripStatusBar';

import Overlay from 'Components/Overlay/FullWidthOverlay';
import { getUser } from 'Utils/storage';
import ClassNames from 'classnames';


class MultiModeAddTrip extends Component {
   constructor(props) {
      super(props);
      const trip = props.trip || new Trip();
      this.viewMode = props.viewMode;

      const {
         //Keep this as it is even if its not required. Client might ask to prefill again :P
         vehicleTypes,
         vehicleBodyTypes,
         paymentCycles,
         businessVolumes,
         pricingBasis,
         qbr,
         rfqServiceType,
         rfqType,
         disablePlacementTime,
         to,
         from,
         remarks,
         rfqBiddingDetails,
         rfq
      } = props;

      if (!props.trip) {
         trip.addStop();
         trip.addStop();
         trip.addLCLStop();
         trip.addLeg();
         trip.addCost();

         //Presetting values for Trips
         if(rfqType === 5) {
            if(HIKAL.includes(getUser().companyId) && (rfq.rfqDetails || {}).serviceCategoryType === 1 && rfqServiceType === 5){
               trip.setVehicleType(208, 'Less than Container Load (LCL)');
               trip.setVehicleBodyType(29, 'General Purpose');
            }
            trip.legs[0].setBusinessVolumeUnit({ value: 8, name: "Container Load"});
         }
         if (rfqServiceType === 1 || rfqServiceType === 4) {
            // trip.setVehicleType(vehicleTypes[0].value, vehicleTypes[0].name);
            // trip.setVehicleBodyType(vehicleBodyTypes[0].value, vehicleBodyTypes[0].name);
         }

         trip.biddingDetails.setPricingBasis(pricingBasis[0]);
         trip.biddingDetails.setPaymentCycle(paymentCycles[0]);
         //trip.biddingDetails.setBusinessVolumeUnit(businessVolumes[0]);
         trip.biddingDetails.setTatUnit(TAT_UNITS[0]);
         trip.biddingDetails.setPaymentTerms(2, null, 'To Be Billed');

         trip.biddingDetails.setPricingBasis({
            value: rfqBiddingDetails.pricingBasis,
            name: rfqBiddingDetails.pricingBasisName
         });
         trip.biddingDetails.setPaymentCycle({
            value: rfqBiddingDetails.paymentCycle,
            name: rfqBiddingDetails.paymentCycleName
         });
         trip.biddingDetails.setPaymentTerms(rfqBiddingDetails.paymentTerms, null, (rfqBiddingDetails.paymentTerms === 2 ? 'To Be Billed': 'To Pay'));
         trip.biddingDetails.setFrom(rfqBiddingDetails.from);
         trip.biddingDetails.setTo(rfqBiddingDetails.to);
      }
      this.state = {
         activeView: (((rfqType === 1 && (rfqServiceType === 1 || rfqServiceType === 4)) || rfqType === 2 || rfqType === 5) || !disablePlacementTime) ? 1 : 2,
         trip: trip,
         isMinimized: false,
         showError: {
            "from": false,
            "to": false
         },
         vehicleDetailsSubmitted: false,
         stopDetailsSubmitted: false,
         biddingDetailsSubmitted: false,
         lppDetails: {},
         baseCurrencySubmitted : false
      }
      this.viewMode = props.viewMode;
   }
   minimizeTrip = () => {
      this.setState({
         isMinimized: true
      })
   }
   maximizeTrip = () => {
      this.setState({
         isMinimized: false
      })
   }

   nextView = () => {
      const { activeView } = this.state;
      const { trip } = this.state;
      const {
         rfqServiceType,
         rfqType,
         addTrip,
         rfq
      } = this.props;

      let costhead = [];

      if(activeView === 1 && rfqType === 5 && ((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true) && (trip.cargoParticularList || []).reduce((sum, el) => sum += Number(el.chargableWeight), 0) === 0) {
         this.setState({
            vehicleDetailsSubmitted: true
         });
         return;
      }

      if(activeView === 2 && rfqType === 5 && trip && (!trip.priceInBaseCurrency)) {
         this.setState({
            baseCurrencySubmitted: true
          });
         return;
      }
      if(HIKAL.includes(getUser().companyId) && activeView === 2 && rfqType === 5) {
         const apiData = trip.getApiData(rfqType, rfqServiceType);
         (apiData.stops || []).forEach(stop => {
            costhead = [ ...costhead, 
               ...(stop.multi_mode_heading_charges || []).filter(charge => !(charge.headingChargesValue && charge.headingChargesUnitName))]
         });
      }
      if(HIKAL.includes(getUser().companyId) && activeView === 2 && rfqType === 5 && trip && costhead.length > 0) {
         this.setState({
            baseCurrencySubmitted: true
          });
         return;
      }

      if (rfqType !== 2 && (rfqServiceType === 1 || rfqServiceType === 4) && activeView === 1 && ((rfqType === 5 && HIKAL.includes(getUser().companyId) && (rfq.rfqDetails || {}).serviceCategoryType === 2) ?  false : (!trip.vehicleBodyType || !trip.vehicleType))) {
         this.setState({
            vehicleDetailsSubmitted: true
         });
         return;
      }
      if(activeView === 2 && trip.legs.find(leg => !((leg.from && leg.from.location) && (leg.to && leg.to.location)))) {
         this.setState({
                    stopDetailsSubmitted: true
                  });
         return;
      }
      // else if(rfqType === 1 && (rfqServiceType ===1 || rfqServiceType === 4) && activeView === 2 && (!trip.stops[0].location || !trip.stops[1].location)) {
      //     this.setState({
      //         stopDetailsSubmitted: true
      //     });
      //     return;
      // } else if(rfqType === 1 && rfqServiceType === 4 && activeView === 2 && !trip.consigners[0]) {
      //     this.setState({
      //         stopDetailsSubmitted: true
      //     });
      //     return;
      // }
      // else if(activeView === 4 && rfqServiceType === 4
      //         // && (!trip.biddingDetails.pricingBasis || !trip.biddingDetails.paymentCycle || !trip.biddingDetails.businessVolumeUnit || !trip.biddingDetails.tatUnit)
      //         && (!trip.biddingDetails.businessVolumeUnit || !trip.biddingDetails.businessVolumeValue)
      //         ) {
      //     this.setState({
      //         biddingDetailsSubmitted: true
      //     });
      //     return;
      // }

      if (rfqServiceType === 4 && activeView === 2) {
         if (trip.consignees[0] && !trip.consignees[0].consignee_name) {
            trip.consignees[0].consignee_details = trip.stops[1];
            trip.consignees[0].consignee_name = trip.stops[1].location;
            trip.consignees[0].consignee_id = '';
         }
         else {
            if (!trip.consignees[0]) {
               trip.consignees = [];
               const obj =
               {
                  consignee_details: trip.stops[1],
                  consignee_name: trip.stops[1].location,
                  consignee_id: ''
               }
               trip.consignees.push(obj);
            }
         }
      }
      // if(rfqType === 1 && (rfqServiceType ===1 || rfqServiceType === 4) && activeView === 2 ) {
      //     this.props.getQBR({
      //         vehicle_type: trip.vehicleType,
      //         vehicle_body_type: trip.vehicleBodyType,
      //         from: trip.stops[0].location,
      //         to: trip.stops[1].location
      //     }, (qbr)=> {
      //         if(!trip.biddingDetails.qbr) {
      //             trip.biddingDetails.setQbr(qbr);
      //             this.onChange();
      //         }
      //     });
      //     const user = getUser();
      //     this.props.dispatch({
      //         type: GET_LPP_DETAILS,
      //         data: {
      //             rfqType: {
      //                     companyId: (user && user.companyId) ? user.companyId : null,
      //                     source: trip.stops[0].location,
      //                     destination: trip.stops[1].location,
      //                     vehicle_type: trip.vehicleTypeName,
      //                 }
      //         },
      //         onSuccess: ((data)=> {
      //             this.setState({
      //                 tripRouteCode:data.rfqType.route_code ? data.rfqType.route_code : null,
      //                 lppDetails: data.rfqType,
      //             }, () => {
      //                 const { trip, lppDetails } = this.state;
      //                 if (lppDetails && Object.keys(lppDetails).length > 0 && lppDetails.distance) {
      //                     trip.biddingDetails.setTatValue(Math.round(parseFloat(lppDetails.distance.replace(/[\s,]+/g,'')) / AVG_DISTANCE));
      //                     trip.biddingDetails.setTatUnit({ name:"Days", value:1 });
      //                     this.setState({ trip });
      //                 }
      //             });
      //         })
      //     })
      // }
      if ((rfqType === 2 || rfqType === 5) && activeView !== 2) {
         this.setState({
            activeView: 2
         });
      }
      // else if(activeView !== 2) {
      //     this.setState({
      //         activeView: activeView + 1
      //     });
      // }
      else if (this.state.activeView === 2) {
         const apiData = this.state.trip.getApiData(rfqType, rfqServiceType);
         // apiData.route_code = this.state.tripRouteCode ? this.state.tripRouteCode : null;
         // apiData.distance = this.state.lppDetails ? this.state.lppDetails.distance : null;
         // apiData.distance_uom = this.state.lppDetails ? this.state.lppDetails.distance_uom: null;
         // apiData.lpp=this.state.lppDetails.lpp;
         addTrip(apiData, false);
      }
   }
   saveAndKeepAdding = () => {
      const { trip, activeView } = this.state;
      const { rfqServiceType, rfqType, addTrip } = this.props;

      const apiData = this.state.trip.getApiData(rfqType, rfqServiceType);
      let costhead = [];
      if(HIKAL.includes(getUser().companyId) && activeView === 2 && rfqType === 5) {
         (apiData.stops || []).forEach(stop => {
            costhead = [ ...costhead, 
               ...(stop.multi_mode_heading_charges || []).filter(charge => !(charge.headingChargesValue && charge.headingChargesUnitName))]
         });
      }
      if(HIKAL.includes(getUser().companyId) && activeView === 2 && rfqType === 5 && costhead.length > 0) {
         this.setState({
            baseCurrencySubmitted: true
          });
         return;
      }
      // apiData.route_code = this.state.tripRouteCode ? this.state.tripRouteCode : null;
      // apiData.distance = this.state.lppDetails ? this.state.lppDetails.distance : null;
      // apiData.distance_uom = this.state.lppDetails ? this.state.lppDetails.distance_uom: null;
      // apiData.lpp=this.state.lppDetails.lpp;
      addTrip(apiData, true);
      // if(activeView === 2 && rfqServiceType === 4 && (!trip.biddingDetails.businessVolumeUnit || !trip.biddingDetails.businessVolumeValue)) {
      //     console.log("this is test propsss");
      //     this.setState({
      //         vehicleDetailsSubmitted: true
      //     });
      //     return;
      if (activeView == 2 && activeView !== 2) {
         this.setState({
            activeView: 1
         });
      }

   }
   previousView = () => {
      const { activeView } = this.state;
      const { rfqType } = this.props;
      if (rfqType === 1 && activeView === 4) {
         this.setState({
            activeView: 2
         });
      } else if (activeView !== 1) {
         this.setState({
            activeView: activeView - 1
         })
      }
   }
   onChange = () => {
      this.setState({
         trip: this.state.trip
      }, () => {
         const { trip } = this.state;
         this.setState({
            showError: {
               from: trip.stops[0].location == '',
               to: trip.stops[1].location == ''
            }
         });
      })
   }
   deleteTrip = () => {
      const { trip } = this.state;
      this.props.deleteTrip(trip);
   }

   isRoundTripChange = (isRoundTrip) => {
      const { trip } = this.state;
      trip.isRoundTrip = isRoundTrip;
      this.setState({ trip });
   }

   componentWillReceiveProps(nextProps) {
      const { activeView } = this.state;
      if (this.props && nextProps.isTripExists && activeView === 4) {
         this.setState({ activeView: 1 });
         this.props.resetTripStatus(null);
      }
   }

   render() {
      const {
         rfqServiceType,
         rfqType,
         disablePlacementTime,
         productCategories,
         vehicleTypes,
         vehicleBodyTypes,
         paymentCycles,
         businessVolumes,
         pricingBasis,
         slabs,
         qbr,
         autoSuggestLocations,
         getNetWorkData,
         networkData,
         multiLevelMovementType,
         otherCosts,
         secondaryContractType,
         currencyDetails,
         currencyTypes,
         rfq,
         costHeadList
      } = this.props;

      const { activeView, trip, isMinimized, showError, vehicleDetailsSubmitted, stopDetailsSubmitted, biddingDetailsSubmitted , baseCurrencySubmitted} = this.state;
      return (
         <Fragment>
            {!isMinimized && <Overlay>
               <div className="box-shadow br-5 pr flex">
                  <div className={ClassNames("pt-20 pb-20 ht-600 overflowAuto",{
                     'wt-1000': rfqType === 5 && activeView === 2 ? false : true,
                     'col-1': rfqType === 5 && (activeView === 2 || HIKAL.includes(getUser().companyId))
                  })}>
                     <div className="pl-20 pr-10 pb-50">
                        <div className="flex flex-middle border-bottom-light-2 pb-10">
                           <Heading text={`Add ${rfqType === 5 ? `EXIM ${HIKAL.includes(getUser().companyId) ? (rfq.rfqDetails || {}).serviceCategoryTypeName : ''}` : 'Multi Mode'} New Trip`} className="flex-1" />
                           <div className="flex flex-between" >
                              {trip.id && !this.viewMode && <div className="flex mr-20 curP" onClick={this.deleteTrip}>
                                 <TrashIcon className="theme-fill ht-12 wt-12 mr-5" />
                                 <span className="theme-color fs-14 fBold">Delete</span>
                              </div>}
                              <div className="flex mr-20 curP" onClick={this.props.hideAddTrip}>
                                 <CloseIcon className="theme-fill ht-12 wt-12 mr-5" />
                                 <span className="theme-color fs-14 fBold">Close</span>
                              </div>
                              <div className="flex flex-middle curP" onClick={this.minimizeTrip}>
                                 <MinimizeIcon className="theme-fill ht-12 wt-12 mr-5" />
                                 <span className="theme-color fs-14 fBold">Minimize</span>
                              </div>
                           </div>
                        </div>
                        {!(HIKAL.includes(getUser().companyId) && rfq.type === 5) && <TripStatusBar rfqType={rfqType} className="mt-40 mb-40" labelhidden={true}/>}
                        <div className="pb-20">
                           {activeView === 1 &&
                              <VehicleDetails
                                 vehicleTypes={vehicleTypes}
                                 vehicleBodyTypes={vehicleBodyTypes}
                                 disablePlacementTime={disablePlacementTime}
                                 trip={trip}
                                 onChange={this.onChange}
                                 viewMode={this.viewMode}
                                 submitted={vehicleDetailsSubmitted}
                                 productCategories={productCategories}
                                 rfqType={rfqType}
                                 shouldShowVehicleTypes={(rfqType === 1 && (rfqServiceType === 1 || rfqServiceType === 4)) || rfqType === 2 || rfqType === 5}
                                 rfqServiceType={rfqServiceType}
                                 rfq={rfq}
                              />}
                           {activeView === 2 && (rfqType === 2 || rfqType === 5) &&
                              <LegDetails
                                 trip={trip}
                                 onChange={this.onChange}
                                 paymentCycles={paymentCycles}
                                 businessVolumes={businessVolumes}
                                 pricingBasis={pricingBasis}
                                 slabs={slabs}
                                 viewMode={this.viewMode}
                                 multiLevelMovementType={multiLevelMovementType}
                                 otherCosts={otherCosts}
                                 secondaryContractType={secondaryContractType}
                                 rfqType={rfqType}
                                 currencyDetails={currencyDetails}
                                 stopDetailsSubmitted={stopDetailsSubmitted}
                                 currencyTypes={currencyTypes}
                                 rfqServiceType={rfqServiceType}
                                 baseCurrencySubmitted = {baseCurrencySubmitted}
                                 rfq={rfq}
                                 costHeadList={costHeadList}
                              />}
                           {/* {activeView === 3 &&  
                                        <Costs 
                                            trip = {trip} 
                                            costs={trip.costs} 
                                            onChange={this.onChange}
                                            paymentCycles={paymentCycles}
                                            businessVolumes={businessVolumes}
                                            pricingBasis={pricingBasis}
                                            slabs={slabs}
                                            viewMode = {this.viewMode}
                                        />} */}
                           {/* {
                                        activeView === 4 && 
                                        <BiddingDetails 
                                            type={'addTrip'}
                                            biddingDetails = {trip.biddingDetails} 
                                            onChange={this.onChange}
                                            paymentCycles={paymentCycles}
                                            businessVolumes={businessVolumes}
                                            pricingBasis={pricingBasis}
                                            slabs={slabs}
                                            viewMode = {this.viewMode}
                                            submitted={biddingDetailsSubmitted}
                                            lppDetails={this.state.lppDetails}
                                            viewType="trip"
                                            rfqServiceType={rfqServiceType}
                                        />
                                    } */}
                        </div>

                     </div>
                     <div className={ClassNames("pf bg-white box-shadow flex b-0 ht-60 flex flex-middle flex-right wt-inherit", {
                        // 'wt-71p': rfqType === 5 && activeView === 2 ? false : true,
                        // 'col-1':  rfqType === 5 && activeView === 2
                     })}>
                        {activeView > 1 && <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.previousView}>Previous</button>}
                        {activeView < 2 && <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-50" onClick={this.nextView}>Next</button>}
                        {activeView === 2 && !this.viewMode && <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.nextView}>Save And Close</button>}
                        {activeView === 2 && !this.viewMode && <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.saveAndKeepAdding}>Save And Keep Adding</button>}
                     </div>
                  </div>
                  {(rfqType === 5 && (HIKAL.includes(getUser().companyId) || activeView !== 1)  ? false : true) && <div className="wt-350 ht-600 bg-gray pt-20 pb-20 pl-15 pr-10 overflowAuto">
                     <Heading text="Live preview" className="mb-30" />
                     <img src={TruckPreview} className="wt-300 ht-150 mb-30" alt="lady" />
                     <LivePreview
                        lppDetails={this.state.lppDetails}
                        rfqServiceType={rfqServiceType}
                        rfqType={rfqType}
                        trip={trip}
                        disablePlacementTime={disablePlacementTime}
                        rfq={rfq}
                     />
                  </div>}
               </div>
            </Overlay>}
            {
               isMinimized && <MinimizedTrip maximizeTrip={this.maximizeTrip} hideAddTrip={this.props.hideAddTrip} />
            }
         </Fragment>
      )
   }
}

export default connect(null, null)(MultiModeAddTrip);
